import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SoldBadge.module.css';

/**
 * Small badge used to label listings that have already sold.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @returns {JSX.Element}
 */
const SoldBadge = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <span className={classes}>
      <FormattedMessage id="SoldBadge.label" />
    </span>
  );
};

export default SoldBadge;
